"use client";
import { jsx as o } from "react/jsx-runtime";
import { Portal as i } from "./portal.js";
import { ThemeProvider as n } from "../providers/theme-provider.js";
import { useInkeepConfig as s } from "../providers/config-provider.js";
const l = ({ children: t, ...e }) => {
  const { baseSettings: r } = s(), { rootElement: m } = r;
  return /* @__PURE__ */ o(i, { host: m, ...e, children: /* @__PURE__ */ o(n, { children: t }) });
};
export {
  l as PortalWithTheme
};
